import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'

import Composite from '@vue-storefront/core/mixins/composite'
import { Logger } from '@vue-storefront/core/lib/logger'

export default {
  name: 'Home',
  mixins: [Composite],
  async asyncData ({ store, route, context }) { // this is for SSR purposes to prefetch data
    // console.log(context)
    if (context) context.output.cacheTags.add(`home`)
    Logger.info('Calling asyncData in Partner Categories Page (core)')()
    try {
      await EventBus.$emitFilter('home-after-load', { store: store, route: route })
      await store.dispatch('locations/loadLocations')
    } catch (e) {
      Logger.error(e)()
      throw e
    }
  }
}
